// Conversions.js – Version: v1 i5 (Proxy-Werte angepasst, StageKey-Logik beibehalten)
import { useState, useEffect } from "react";
import "./Conversions.css";
import BackButton from "./BackButton";

// --- NEU DEFINIERTE FUNNEL-OPTIONEN MIT PROXY-WERTEN ---
const defaultFunnelOptions = [
  { label: "Offline - Webinar Engagiert (4 €)", value: 4.00, stageKey: "Offline_Webinar_Engagiert" },
  { label: "Offline - Erstgespräch Gebucht (5 €)", value: 5.00, stageKey: "Offline_Erstgespraech_Gebucht" },
  { label: "Offline - Erstgespräch Geführt (6 €)", value: 6.00, stageKey: "Offline_Erstgespraech_Gefuehrt" },
  { label: "Offline - Strategiegespräch Geführt (7 €)", value: 7.00, stageKey: "Offline_Strategiegespraech_Gefuehrt" },
  { label: "Offline - Coaching Starter Gebucht (8 €)", value: 8.00, stageKey: "Offline_Coaching_Starter_Gebucht" },
  { label: "Offline - Coaching Kunde (pauschal 10 €)", value: 10.00, stageKey: "Offline_Coaching_Kunde_C1_C5" }, // Pauschalwert für alle C-Stufen
  // Die Option "Kein Coaching" oder eine Null-Wert-Option wird über das "Bitte wählen" im Select abgedeckt
  // und die Logik in sendToGADS (value <= 0)
];
// --- ENDE NEU DEFINIERTE FUNNEL-OPTIONEN ---

export default function Conversions() {
  const [conversions, setConversions] = useState([]);
  const [funnelOptions] = useState(defaultFunnelOptions);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchConversions = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await fetch("https://freiseinapp.de/api/get_conversions.php", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        if (response.ok) {
          const data = await response.json();
          console.log("📡 Antwort Conversions:", data);
          if (data.success) {
            const sanitizedConversions = data.conversions.map(conv => ({
                ...conv,
                conversion_value: conv.conversion_value !== null ? Number(conv.conversion_value) : null,
            }));
            setConversions(sanitizedConversions);
          } else {
            setError(data.error || "Fehler beim Laden der Konversionen.");
          }
        } else {
           const errorText = await response.text();
           console.error("HTTP-Fehler:", response.status, errorText);
           setError(`Fehler ${response.status}: API für Conversions antwortet nicht oder fehlerhaft.`);
        }
      } catch (error) {
        console.error("❌ Fehler beim Laden der Conversions:", error);
        setError("Netzwerkfehler oder Server nicht erreichbar beim Laden der Conversions.");
      } finally {
        setLoading(false);
      }
    };

    fetchConversions();
  }, []);

  const handleValueChange = async (index, newValue) => {
    const currentConversions = [...conversions];
    const updatedConversions = [...conversions];
    const selectedConversion = updatedConversions[index];

    updatedConversions[index] = { ...selectedConversion, conversion_value: newValue };
    setConversions(updatedConversions);


    try {
      const response = await fetch("https://freiseinapp.de/api/update_conversion.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ id: selectedConversion.id, conversion_value: newValue }),
      });

      const result = await response.json();
      if (!result.success) {
         console.error("Fehler beim Speichern des Wertes:", result.error);
         alert(`❌ Fehler beim Speichern des Wertes: ${result.error || 'Unbekannter Fehler'}`);
         setConversions(currentConversions); 
      }
    } catch (err) {
      console.error("❌ Netzwerkfehler bei: update_conversion", err);
      alert("❌ Netzwerkfehler beim Speichern des Wertes.");
      setConversions(currentConversions);
    }
  };

  const sendToGADS = async (conversion) => {
    const gclid = conversion.gclid?.trim();
    const valueInput = conversion.conversion_value;
    // Stelle sicher, dass der Wert korrekt als Zahl geparst wird, auch wenn er "" (aus "Bitte wählen") ist
    const value = (valueInput !== null && valueInput !== "" && !isNaN(Number(valueInput))) ? parseFloat(valueInput) : null;

    const selectedOption = funnelOptions.find(opt => opt.value === value);
    const stageKey = selectedOption ? selectedOption.stageKey : null;

    if (!gclid || value === null || value <= 0 || !stageKey) { // Prüfung auf stageKey === "Kein_Coaching" hier entfernt, da nicht in options
      alert("⚠️ Ungültige Daten: GCLID fehlt, Wert ist <= 0 € oder ungültige Funnel-Stufe für GADS-Upload ausgewählt.");
      console.log("GCLID:", gclid, "Value:", value, "StageKey:", stageKey);
      return;
    }

    const payload = {
      gclid: gclid,
      value: value,
      stageKey: stageKey
    };

    console.log("📦 GADS Payload vor dem Senden:", payload);

    try {
      const response = await fetch("https://freiseinapp.de/api/send_conversion_to_gads.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Antwort vom Server:", result);

      if (result.success) {
        alert("📤 Conversion erfolgreich an GADS gesendet.");
        const nowISO = new Date().toISOString();
        const updatedConversions = conversions.map(conv => {
          if (conv.id === conversion.id) {
            return { ...conv, last_send: nowISO };
          }
          return conv;
        });
        setConversions(updatedConversions);
      } else {
        const errorMessage = result.details || result.error || 'Unbekannter Fehler';
        alert(`❌ Fehler beim Senden an GADS: ${errorMessage}`);
        console.error("Fehlerdetails von send_conversion_to_gads:", result);
      }
    } catch (err) {
      console.error("Netzwerkfehler bei: send_conversion_to_gads", err);
      alert("❌ Netzwerkfehler beim Senden an GADS.");
    }
  };

  const logConversionAction = async (conversion) => {
    try {
        const response = await fetch("https://freiseinapp.de/api/log_conversion_action.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            email: conversion.email,
            value: conversion.conversion_value,
            event: "manuelle_protokollierung",
            gclid: conversion.gclid,
            keyword: conversion.keyword,
          }),
        });
        const result = await response.json();
        if (result.success) {
          alert("✅ Conversion-Aktion protokolliert.");
        } else {
          alert("❌ Fehler beim Protokollieren der Conversion-Aktion.");
          console.error("Fehler beim Protokollieren:", result);
        }
      } catch (error) {
        console.error("❌ Netzwerkfehler beim Protokollieren:", error);
        alert("❌ Netzwerkfehler beim Protokollieren der Conversion.");
      }
  };


  if (loading) return <p>📡 Laden...</p>;
  if (error) return <p>❌ {error}</p>;

  return (
    <div className="conversions-container">
      <h2>📊 Alle Konversionen</h2>
      <div className="back-button-wrapper">
        <BackButton to="/admin" />
      </div>
      <table>
        <thead>
          <tr>
            <th>Email</th>
            <th>Wert / Funnel-Stufe</th>
            <th>Keyword</th>
            <th>GCLID</th>
            <th>Erstellt</th>
            <th>Gesendet</th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          {conversions.length > 0 ? (
            conversions.map((conv, index) => (
              <tr key={conv.id}>
                <td>{conv.email || "N/A"}</td>
                <td>
                  <select
                    value={conv.conversion_value !== null ? Number(conv.conversion_value) : ""}
                    onChange={(e) => handleValueChange(index, e.target.value === "" ? null : parseFloat(e.target.value))} // Erlaube "Bitte wählen" (null)
                  >
                    <option value="">Bitte wählen</option>
                    {funnelOptions.map((opt, idx) => (
                      <option key={idx} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </td>
                <td>{conv.keyword || "Kein Keyword"}</td>
                <td>{conv.gclid || "Kein GCLID"}</td>
                <td>{conv.created_at ? new Date(conv.created_at).toLocaleString('de-DE') : "N/A"}</td>
                <td>{conv.last_send ? new Date(conv.last_send).toLocaleString('de-DE') : "–"}</td>
                <td>
                  <button onClick={() => sendToGADS(conv)}>📤 GADS</button>
                  <button onClick={() => logConversionAction(conv)}>📝 Log</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">Keine Konversionen gefunden.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
